const MONO_FONT = 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace';

export const richHtmlSx = {
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontWeight: 700,
    lineHeight: 1.25,
    margin: '0.6em 0 0.3em',
    color: 'inherit',
  },
  '& h1': { fontSize: '1.6em' },
  '& h2': { fontSize: '1.35em' },
  '& h3': { fontSize: '1.15em' },
  '& h4': { fontSize: '1em' },
  '& h5, & h6': { fontSize: '0.9em', textTransform: 'uppercase', letterSpacing: '0.04em' },
  '& p': { margin: '0 0 0.6em' },
  '& p:last-child': { marginBottom: 0 },
  '& a': {
    color: 'primary.main',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    '&:hover': { textDecoration: 'none' },
  },
  '& ol': { listStyle: 'revert', pl: { xs: 3, md: 5 }, margin: 0 },
  '& ul': { listStyle: 'revert', pl: { xs: 3, md: 5 } },
  '& pre': {
    backgroundColor: 'grey.300',
    color: 'common.black',
    fontFamily: MONO_FONT,
    fontSize: 13,
    lineHeight: 1.5,
    padding: '12px 14px',
    borderRadius: 1,
    overflowX: 'auto',
    margin: '8px 0',
    whiteSpace: 'pre',
  },
  '& pre code': {
    background: 'transparent',
    color: 'inherit',
    padding: 0,
    fontSize: 'inherit',
    fontFamily: 'inherit',
    borderRadius: 0,
  },
  '& :not(pre) > code': {
    fontFamily: MONO_FONT,
    fontSize: '0.9em',
    backgroundColor: 'action.hover',
    padding: '1px 4px',
    borderRadius: 0.5,
  },
  '& blockquote': {
    borderLeft: '3px solid',
    borderColor: 'divider',
    margin: '8px 0',
    padding: '4px 12px',
    color: 'text.secondary',
  },
};
